/* @flow */
/**
 * External dependencies
 */
import { HelmetProvider } from 'react-helmet-async';
import { includes, noop } from 'lodash';
import { Provider } from 'react-redux';
import Cookies from 'universal-cookie';
import Loadable from 'react-loadable';
import React from 'react';
import ReactDOM from 'react-dom';

/**
 * Internal dependencies
 */
import { accessibleFocus } from './utils/accessible-focus';
import { canUseDOM } from './utils/canUseDom';
import { initStore } from './store';
import { setDoneState } from 'shared/state';
import * as serviceWorker from './serviceWorker';
import Routes from './routes';

/**
 * Polyfills
 */
import 'babel-polyfill';

/**
 * Style
 */
import 'sanitize.css';

const cookies = new Cookies();

// Reset app
const reset = () => {
	cookies.remove( 'brukHueState', { path: '/' } );
};

if ( includes( window.location.pathname, 'reset' ) ) {
	reset();
	window.history.replaceState( {}, 'Bruk Hue', '/' );
}

const initialReduxState = cookies.get( 'brukHueState' ) || {};
const store = initStore( setDoneState( initialReduxState ) );
const renderMethod = ! canUseDOM ? ReactDOM.hydrate : ReactDOM.render;
const apiData = window.__SERVER_DATA__ || {};

accessibleFocus( store.dispatch );

function boot() {
	const rootElement = document.getElementById( 'root' );

	if ( ! rootElement ) {
		throw new Error( 'Root element doesn\'t exists' );
	}

	return renderMethod(
		<Provider store={ store }>
			<HelmetProvider>
				<Routes cachedData={ apiData } reset={ reset } />
			</HelmetProvider>
		</Provider>,
		rootElement
	);
}

Loadable.preloadReady().then( boot );
serviceWorker.register( {
	onSuccess: noop,
	onUpdate: noop,
} );



// WEBPACK FOOTER //
// ./src/index.js